import { TextField } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface DeliveryNoteProps {
    value?: string;
    onChange: (value?: string) => void;
}

export const DeliveryNote: React.FC<DeliveryNoteProps> = ({ value, onChange }) => {
    const { t } = useTranslation();
    const handleChange = React.useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            onChange(e.target.value);
        },
        [onChange]
    );
    return (
        <TextField
            size="small"
            value={value}
            onChange={handleChange}
            fullWidth
            label={t('DELIVERY_ADDRESS_NOTE')}
        />
    );
};
